import { LinkType } from '@tv2/lib-offspring/types/LinkType';
import { WithLink } from '@tv2/lib-offspring/types/DeckType';
import { CASDecksType } from '../../search-page/components/CASDecksType';

export function decksWithTracking<T extends CASDecksType>(decks: Array<T>, path: string): Array<T> {
  return (
    decks.map((d, i) => {
      return deckWithTracking(d, i, path);
    }) || []
  );
}

export function deckWithTracking<T extends CASDecksType>(
  deck: T,
  deckIndex: number,
  path: string
): T {
  return deckLinkWithTracking(deckCardsWithTracking(deck, path, deckIndex), path, deckIndex);
}

export function deckLinkWithTracking<T extends CASDecksType>(
  deck: T,
  path: string,
  deckIndex: number
): T {
  if ('link' in deck) {
    return {
      ...deck,
      link: rawToReadyLink(deck.link, deckIndex, 0, path),
    };
  }
  return deck;
}

export function deckCardsWithTracking<T extends CASDecksType>(
  deck: T,
  path: string,
  deckIndex: number
): T {
  const hasCards = 'cards' in deck;
  if (!hasCards) return deck;

  const cards = deck.cards.map((c, i) => {
    if ('cards' in deck && c && 'link' in c) {
      return rawToReady(c, deckIndex, i, path);
    }
    return c;
  });

  return {
    ...deck,
    cards,
  };
}

export function rawToReady<T extends WithLink>(
  object: T,
  deckIndex: number,
  entityIndex: number,
  path: string
) {
  return {
    ...object,
    link: rawToReadyLink(object.link, deckIndex, entityIndex, path),
  };
}

export function rawToReadyLink<T extends LinkType | null>(
  object: T,
  deckIndex: number,
  entityIndex: number,
  path: string
): T {
  if (!object) return object;

  const { tracking } = object;

  switch (tracking.status) {
    case 'ready':
    case 'missing':
      return object;
    case 'raw':
      return {
        ...object,
        tracking: {
          status: 'ready',
          icid: {
            context: 'content',
            path,
            structureNumber: deckIndex >= 0 ? deckIndex : 'undefined',
            structureType: tracking.structureType,
            structureTitle: tracking.structureTitle,
            entityNumber: entityIndex >= 0 ? entityIndex : 'undefined',
            teaserType: tracking.teaserType,
            presentationTitle: tracking.presentationTitle,
            deckId: tracking.deckId,
            listId: tracking.listId ?? 'undefined',
            label: tracking.label,
          },
        },
      };
    default:
      return object;
  }
}
